module.exports = __webpack_public_path__ + "img/docbit.1977dc5c.svg";